import { API_BASE_URL } from '../../utils/constants';
import HttpClient from '../../utils/http-client';

class Activity {
  getAllNotes = (id: number, params = {}) =>
    HttpClient.get(`${API_BASE_URL}/v1/activity/all/${id}`, { params });

  getTextNoteDetail = (id: number) =>
    HttpClient.get(`${API_BASE_URL}/v1/activity/text-note/${id}`);
  
  createTextNote = (payload) =>
    HttpClient.post(`${API_BASE_URL}/v1/activity/text-note`, payload);
  
  updateTextNote = (payload) =>
    HttpClient.put(`${API_BASE_URL}/v1/activity/text-note`, payload);

  deleteTextNote = (id: number) =>
    HttpClient.delete(`${API_BASE_URL}/v1/activity/text-note/${id}`);
  
}

const ActivityService = new Activity();
export default ActivityService;